/**
 * External Dependencies
 */
import Swiper, { Navigation, Pagination, Controller, EffectFade } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination, Controller, EffectFade]);

if (document.getElementById('toggle-menu')) {
	document.getElementById('toggle-menu').addEventListener('click', () => {
		document.getElementById('navigation').classList.toggle('is-menu-open');
	});
}

if (document.getElementById('open-search')) {
	document.getElementById('open-search').addEventListener('click', () => {
		document.getElementById('search-panel').classList.toggle('is-search-open');
		document.getElementById('search-field').focus();
	});
}

if (document.getElementById('close-search')) {
	document.getElementById('close-search').addEventListener('click', () => {
		document.getElementById('search-panel').classList.toggle('is-search-open');
	});
}

const sliderBestsellers = new Swiper('.slider-bestsellers', {
	loop: true,
	autoplay: {
		delay: 5000
	},
	initialSlide: 0,
	slidesPerView: 1,
	navigation: {
		nextEl: '.section-bestsellers .button-next',
		prevEl: '.section-bestsellers .button-prev',
		disabledClass: 'opacity-50'
	},
});

const sliderTrending = new Swiper('.slider-trending', {
	loop: true,
	effect: 'fade',
	initialSlide: 0,
	slidesPerView: 1,
	pagination: {
		el: '.slider-trending .pagination',
		type: 'fraction',
	},
	navigation: {
		nextEl: '.slider-trending .button-next',
		prevEl: '.slider-trending .button-prev',
		disabledClass: 'opacity-50'
	}
});

const sliderProduct = new Swiper('.slider-product', {
	initialSlide: 0,
	slidesPerView: 1,
	loop: true,
	pagination: {
		el: '.pagination',
		type: 'fraction',
	},
	navigation: {
		nextEl: '.button-next',
		prevEl: '.button-prev',
		disabledClass: 'opacity-50'
	},
});

const initTabs = () => {
	//console.log('tabs');
	const tabs = document.querySelectorAll('#tabs button');
	const contents = document.querySelectorAll('#tabs .entry-content');
	//console.log(tabs, contents);

	tabs.forEach(tab => {
		//console.log(tab);
		tab.addEventListener('click', e => {
			//console.log(e);
			e.preventDefault();
			removeActiveTab();
			addActiveTab(tab);
		});
	});

	const addActiveTab = tab => {
		tab.classList.add('is-active');
		const id = tab.dataset.tab;
		const matchingContent = document.querySelectorAll(`#tabs .entry-content[data-tab="${id}"]`);
		matchingContent[0].classList.add('is-active');
	}

	const removeActiveTab = () => {
		tabs.forEach(tab => {
			tab.classList.remove('is-active');
		});
		contents.forEach(content => {
			content.classList.remove('is-active');
		});
	}
}

initTabs();
